import { Component, computed, ViewChild, ElementRef, Output, EventEmitter, NgZone, effect, Input, signal, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { GenericValidationService } from '@app/common-codes/services/GenericValidationService';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { ActivatedRoute, Router } from '@angular/router';
import { OnReadyDirective } from '@app/common-codes/components/directives/OnReadyDirective';
import { FieldContextDirective } from '@app/common-codes/components/directives/FieldContext.directive';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { Account } from '@app/common-codes/models/matwins-tenant/Account.model';
import { Account_POS } from '@app/common-codes/models/matwins-tenant/navigation-entities/Account_POS.model';
import { LookupItem, LookupService } from '@app/common-codes/services/LookupService';
import { MultiSelectComponent } from '@app/common-codes/components/nested-components/multi-select/multi-select.component';
import { PermissionsService } from '@app/common-codes/services/Permissions.service';
import { AccountBase } from '@app/common-codes/models/AccountBase.model';
import { AccountBaseDetailComponent } from '@app/components/account/accountBase-detail.component';
import { FieldWrapperComponent } from '@app/common-codes/components/nested-components/field-wrapper/field-wrapper.component';


@Register(Account)
@Component({
  selector: 'app-tenant-account-detail',
  templateUrl: './account-detail.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, TranslatePipe, OnReadyDirective, MultiSelectComponent, FieldWrapperComponent, FieldContextDirective]
})
export class TenantAccountDetailComponent extends AccountBaseDetailComponent<Account> {

  override ComponentEntityClass = Account;
  @Input() fkPointOfServiceId: number | null = null;
  pointOfServiceLookup = signal<LookupItem[]>([]);
  posResponsible: LookupItem[] = [];


  constructor(
    route: ActivatedRoute,
    router: Router,
    translationService: TranslationService,
    validationService: GenericValidationService,
    alertModalService: AlertModalService,
    permissionsService: PermissionsService,
    ngZone: NgZone
  ) {
    super(route, router, translationService, validationService, alertModalService, permissionsService, ngZone);
    this.alertModalService = alertModalService;
    effect(() => {
      const entity = this.editingEntity();
      if (entity) {
        // Lire la revision : si les listes arrivent en retard, l'effet repasse et les remplit.
        this.lookupService.revision();
        this.roleLookup.set(this.getLookupData('Role', 'Matwins.Core.Model.MatwinsTenant'));
        this.languageLookup.set(this.getLookupData('i18nLanguage'));
        let posLookup = this.lookupService.getLookupData('PointOfService');

        this.pointOfServiceLookup.set(posLookup);
        this.loadAccount();


        this.posResponsible = [];
        posLookup.forEach(pos => {
          let isResponsible = 0;

          //lire dans entity.employeePOS
          if (entity.accountPOS && entity.accountPOS.length > 0)
            isResponsible = entity.accountPOS.some((r: Account_POS) => r.fK_POS === parseInt(pos.id) && r.isTruckerResponsible) ? 1 : 0;

          pos.selectedValue = isResponsible;
          pos.children = [{ id: '0', key: '0', value: pos.value, visible: true, additionalData: { containerdisplaystate: 'containerMultiSelectBadge  rounded success', displaystate: "multiSelectbadge" } },
          { id: '1', key: '1', value: `${pos.value} (R)`, visible: true, additionalData: { containerdisplaystate: 'containerMultiSelectBadge  rounded warning', truckerresponsibleicon: pos.additionalData['truckerresponsibleicon'], displaystate: "multiSelectbadge" } }
          ];
          this.posResponsible.push(pos);
        });
      }
    });
  }

  loadAccount() {
    // const selected = this.editingEntity()?.accountPOS?.map(ap => `${ap.fK_POS}`) ?? [];
    // this.selected = selected;
    const entity = this.editingEntity();
    if (!entity) {
      return;
    }
    const selected = this.editingEntity()?.accountPOS?.map(ap => `${ap.fK_POS}`) ?? [];
    if (!selected) {
      return;
    }
    entity.selectedPK_Pos = selected;
  }

  override getEmptyEntity(): Account {
    const account = new Account();
    account.permissions = '{}';
    const posId = this.matwinsVariables?.posId;
    if (posId) {
      let accountPos = new Account_POS();
      accountPos.fK_POS = posId;
      accountPos.fK_Account = 0;
      account.accountPOS = [accountPos];
      account.selectedPK_Pos = account.accountPOS.map(ap => `${ap.fK_POS}`);
    }
    else {
      // const allPos = this.mediator?.getSubLevelData('pointOfServices')();
    }
    return account;
  }

  onLanguageChange(newValue: number): void {
    const currentEntity = this.editingEntity();
    if (currentEntity) {
      // const newEntity = Object.assign(new T(), currentEntity);
      // newEntity.fK_i18nLanguage = newValue;
      // this.editingEntity.set(newEntity);
      currentEntity.fK_i18nLanguage = newValue;
      this.editingEntity.set(currentEntity);
    }
  }

  onPOSselectChange(evt: string[]) {
    const account = this.editingEntity();
    if (!account) {
      return;
    }

    const selectedPosIds = (evt ?? [])
      .map(k => Number(k))
      .filter(n => Number.isFinite(n));

    const existing = account.accountPOS ?? [];
    account.accountPOS = selectedPosIds.map(posId => {
      const found = existing.find(a => a.fK_POS === posId);
      if (found) {
        return found;
      }
      const accountPos = new Account_POS();
      accountPos.fK_POS = posId;
      accountPos.fK_Account = account?.id ?? accountPos.fK_Account;
      return accountPos;
    });
    account.selectedPK_Pos = evt;

  }

  onPosResponsibleChanged(statusObject: { key: string, status: number }) {
    console.log(statusObject);
    const account = this.editingEntity();
    if (!account) {
      return;
    }
    console.log(statusObject);

    if (statusObject.status === 1) {
      const empPos = account.accountPOS?.find(pos => pos.fK_POS === Number(statusObject.key));
      if (!empPos) {
        const employeePos = new Account_POS();
        employeePos.fK_POS = Number(statusObject.key);
        employeePos.fK_Account = account.id;
        employeePos.isTruckerResponsible = true;
        account.accountPOS?.push(employeePos);
      }
      else {
        empPos.isTruckerResponsible = true;
      }
    } else {
      const empPos = account.accountPOS?.find(pos => pos.fK_POS === Number(statusObject.key));
      if (empPos) {
        empPos.isTruckerResponsible = false;
      }
    }

  }


  sendAgreements() {
    console.log('sendAgreements');
  }

  // Je l'ai AJOUTÉ pour gérer les multiselect avec plusieurs choix 
  override updateFromCache(entity: Account): void {
    super.updateFromCache(entity);

    const current = this.editingEntity();
    if (!current) return;

    if (entity.accountPOS) {
      const newSelected = entity.accountPOS
        .map(ap => ap.fK_POS?.toString())
        .filter(k => k != null) as string[];

      if (JSON.stringify(current.selectedPK_Pos) !== JSON.stringify(newSelected)) {
        current.selectedPK_Pos = newSelected;
      }
    }
  }
}
